/// <amd-module name="TFS/Token/PatTokenPage/Context/PanelContext" />
import { PanelActionCreator, PanelOperationType } from 'Actions/PanelActionCreator';
import { TokenActionCreator } from 'Actions/TokenActionCreator';
import { IPatPageContextValue, PatPageConsumer } from 'Context/PatPageContext';
import * as React from "react";
import { Token } from 'Models/Token';

// Initialize Context
export interface IPanelContextValue {
    token?: Token;
    operation?: PanelOperationType;
}

const PanelContext = React.createContext<IPanelContextValue>(undefined as never);

// Provider
export interface IPanelProviderProps {
}

export interface IPanelProviderInternalProps extends IPanelProviderProps {
    panelAction: PanelActionCreator;
    tokenAction: TokenActionCreator;
}

export interface IPanelProviderInternalState {
    token?: Token;
    operation?: PanelOperationType;
}

export class PanelProviderInternal extends React.Component<IPanelProviderInternalProps, IPanelProviderInternalState> {
    constructor(props: IPanelProviderInternalProps) {
        super(props);
        this.addAllListeners(props);

        this.state = {
        };
    }

    public render() {
        const dialogContextValue: IPanelContextValue = { ...this.state };
        return (
            <PanelContext.Provider value={dialogContextValue}>
                {this.props.children}
            </PanelContext.Provider>
        );
    }

    private addAllListeners = (newProps: IPanelProviderInternalProps) => {
        const { panelClosed, tokenPanelOpened } = newProps.panelAction.dispatchers;
        const { addedToken } = newProps.tokenAction.dispatchers;
        panelClosed.addListener((payload) => this.closeCurrentDialog(payload.operation));
        tokenPanelOpened.addListener((payload) => {
            this.openTokenDialog(payload.operation, payload.token);
        });
        addedToken.addListener((payload) => {
            this.openTokenDialog(PanelOperationType.Success, payload.token);
        });
    }

    private readonly openTokenDialog = (operation: PanelOperationType, token?: Token) => {
        this.setState({
            token,
            operation,
        });
    }

    private readonly closeCurrentDialog = (operation: PanelOperationType) => {
        this.setState((prevState, props) => {
            if (prevState.operation !== undefined && prevState.operation === operation) {
                return {
                    token: undefined,
                    operation: undefined,
                }
            }
            return {};
        });
    }
}

export const PanelConsumer = PanelContext.Consumer;

export const PanelProvider = (props: IPanelProviderProps) =>
    <PatPageConsumer>
        {(patPageContext: IPatPageContextValue) =>
            <PanelProviderInternal
                {...props}
                panelAction={PanelActionCreator.getInstance()}
                tokenAction={TokenActionCreator.getInstance(patPageContext.pageContext)}
            />}
    </PatPageConsumer>;
